export { default as ClipboardCopy, ClipboardCopyVariant } from './ClipboardCopy';